import Role from './Role.js';
import Roles from './Roles.js';
import Module from './Module.js';
import Modules from './Modules.js';
import Permission from './Permission.js';
import Permissions from './Permissions.js';
import OidcClient from './OidcClient.js';
import OidcClients from './OidcClients.js';
import ResourceUser from '../users/ResourceUser.js';
import ResourceUsers from '../users/ResourceUsers.js';
import Rule from '../rule/Rule.js';
import Rules from '../rule/Rules.js';
import Enum from '../enums/Enum.js';
import Enums from '../enums/Enums.js';
import ResourceEnums from '../enums/ResourceEnums.js';
import ResourceEnum from '../enums/ResourceEnum.js';
import ApiAccessKey from '../apiAccessKey/ApiAccessKey.js';
import ApiAccessKeys from '../apiAccessKey/ApiAccessKeys.js';
import Blueprints from './Blueprints.js';
import Rsrc from '../rsrc/Rsrc.js';
import MaintenanceEvents from '../maintenanceEvents/MaintenanceEvents.js';
import MaintenanceEvent from '../maintenanceEvents/MaintenanceEvent.js';
import Blueprint from './Blueprint.js';
import ClientIds from '../clientId/ClientIds.js';
import ClientId from '../clientId/ClientId.js';
class Project {
  constructor(id) {
    this.id = id;
  }
  apiAccessKey(apiAccessKeyId) {
    return new ApiAccessKey({
      apiAccessKeyId,
      resourceId: this.id,
      resourceApi: getProjectApi
    });
  }
  apiAccessKeys() {
    return new ApiAccessKeys({
      resourceId: this.id,
      resourceApi: getProjectApi
    });
  }
  users() {
    return new ResourceUsers({
      resourceId: this.id,
      resourceApi: getProjectApi
    });
  }
  user(userId) {
    return new ResourceUser({
      userId,
      resourceId: this.id,
      resourceApi: getProjectApi
    });
  }
  blueprints() {
    return new Blueprints(this.id);
  }
  blueprint(id) {
    return new Blueprint(this.id, id);
  }
  activeMaintenanceEvents() {
    return {
      list: opts => new MaintenanceEvents(this.id).listActive(opts)
    };
  }
  maintenanceEvents() {
    return new MaintenanceEvents(this.id);
  }
  maintenanceEvent(id) {
    return new MaintenanceEvent(this.id, id);
  }
  enums() {
    return new Enums(this.id);
  }
  enum(type) {
    return new Enum(this.id, type);
  }
  resourceEnums() {
    return new ResourceEnums({
      resourceId: this.id,
      resourceApi: this.getRsrcApi,
      isResourceLevel: false
    });
  }
  resourceEnum(type) {
    return new ResourceEnum({
      resourceApi: this.getRsrcApi,
      resourceId: this.id,
      type,
      isResourceLevel: false
    });
  }
  roles() {
    return new Roles(this.id);
  }
  role(id) {
    return new Role(this.id, id);
  }
  modules() {
    return new Modules(this.id);
  }
  module(name) {
    return new Module(this.id, name);
  }
  permissions() {
    return new Permissions(this.id);
  }
  permission(id) {
    return new Permission(this.id, id);
  }

  // dispatch, getState, opts, ownerId, coownerId, path
  getRsrcApi = (dispatch, getState, opts) => {
    const {
      api
    } = opts;
    return api.project(this.id);
  };
  resource(path) {
    return new Rsrc({
      ownerId: this.id,
      coownerId: null,
      path,
      resourceApi: this.getRsrcApi
    });
  }
  oidcClient(id) {
    return new OidcClient(this.id, id);
  }
  oidcClients() {
    return new OidcClients(this.id);
  }
  rules() {
    return new Rules({
      resourceId: this.id,
      resourceType: 'project',
      resourceApi: getProjectApi
    });
  }
  rule(ruleId) {
    return new Rule({
      ruleId,
      resourceId: this.id,
      resourceType: 'project',
      resourceApi: getProjectApi
    });
  }
  clientIds() {
    return new ClientIds({
      resourceId: this.id,
      resourceType: 'project',
      resourceApi: getProjectApi
    });
  }
  clientId(clientIdId) {
    return new ClientId({
      clientIdId,
      resourceId: this.id,
      resourceType: 'project',
      resourceApi: getProjectApi
    });
  }
  twoFactorSettings() {
    return this.api.project(this.id).twoFactorSettings;
  }
  passwordlessLoginSettings() {
    return this.api.project(this.id).passwordlessLoginSettings;
  }
}

/**
 * Creates a new Project with the given id. If the id is not given,
 * process.env.projectId will be used.
 */
function project(id) {
  return new Project(id || process?.env?.projectId);
}
function getProjectApi(dispatch, getState, opts, resourceId) {
  const {
    api
  } = opts;
  const r = api.project(resourceId);
  return r;
}
export default project;